// extracted by mini-css-extract-plugin
export default {"input-wrapper":"InputWrapper_input-wrapper__4iKc2","error":"InputWrapper_error__+3KYh","label":"InputWrapper_label__hhbFD"};